import React, { useState } from 'react';
import { isNil, isNumber } from 'lodash';
import { message } from 'antd';

import GenerateCouponUserDetailModalView from './GenerateCouponUserDetailModalView';
import { useCouponListExcelDownload, useUserDetailGenerateCoupon } from './hooks';
import {
  MAXIMUM_NUMBER_OF_COUPON_ISSUED_COUNT,
  MAXIMUM_NUMBER_OF_COUPON_KIND,
  MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT,
} from '../../../../../../constants/service/app/couponConstants';
import { asyncSimpleModal } from '../../../../../../lib/common';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../../../../constants/service/common/utilConstants';

const GenerateCouponUserDetailModalContainer = (props) => {
  const { userId, closeModal, onValidateGenerateCoupon } = props;
  const [selectedCouponList, setSelectedCouponList] = useState([]);

  const { data, pagination, filterOption, sortOption, getList, handleIssuedCount } = useUserDetailGenerateCoupon({
    userId,
  });
  const { couponList, totalCnt } = data;

  const { getCouponListExcelDownload } = useCouponListExcelDownload();
  const getExcelDownload = () => {
    if (!couponList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getCouponListExcelDownload({
      filterOption,
      sortOption,
    });
  };

  const submitHandler = async () => {
    if (!selectedCouponList || !selectedCouponList.length) {
      message.error('선택된 쿠폰이 없습니다.');
      return;
    }

    /**
     *  발급할 쿠폰 종류는 20 개가 최대
     *  그 이상은 엑셀 업로드를 이용하라고 안내한다.
     */
    if (selectedCouponList.length > MAXIMUM_NUMBER_OF_COUPON_KIND) {
      await asyncSimpleModal({
        type: 'error',
        title: '엑셀 일괄 발급 권장',
        message: `발급할 쿠폰 종류가 너무 많습니다.\n ${MAXIMUM_NUMBER_OF_COUPON_KIND}건 이상은 엑셀 일괄발급을 이용해 주세요.`,
      });
      return;
    }

    /**
     * 선택된 쿠폰의 정보
     */
    let targetList = couponList.filter((item) => selectedCouponList.includes(item.id));
    /**
     *  발급 수량이 유효하지 않을때
     *  issuedCount 를 입력하지 않거나, 숫자가 아닐때, 1~100 장 사이가 아닐때
     */
    if (
      targetList.find(
        (item) =>
          !isNumber(item.issuedCount) ||
          isNil(item.issuedCount) ||
          item.issuedCount > MAXIMUM_NUMBER_OF_COUPON_ISSUED_COUNT ||
          item.issuedCount < MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT,
      )
    ) {
      await asyncSimpleModal({
        type: 'error',
        title: '발급 수량 오류',
        message: '발급 수량은 1에서 100 사이입니다.',
      });
      return;
    }

    onValidateGenerateCoupon(targetList);
    closeModal();
  };

  return (
    <GenerateCouponUserDetailModalView
      list={couponList}
      totalCnt={totalCnt}
      pagination={pagination}
      filterOption={filterOption}
      sortOption={sortOption}
      getList={getList}
      closeModal={closeModal}
      selectedCouponList={selectedCouponList}
      onCheckIssuedCoupon={setSelectedCouponList}
      onSubmit={submitHandler}
      getExcelDownload={getExcelDownload}
      handleIssuedCount={handleIssuedCount}
    />
  );
};

export default GenerateCouponUserDetailModalContainer;
